import React from 'react';
import { Grid, Box, useMediaQuery, useTheme } from '@material-ui/core';

import {
  StyledContainer,
  FAQWrapper,
  MyServicesWrapper,
  MyBlocContainer,
} from 'components/DashboardLayout/styles';
import { injectIntl, IntlShape } from 'react-intl';
import { MediumSectionHeader, SmallSectionHeader } from 'components/Typography';
import { translate } from 'helpers/intl';
import messages from 'components/DashboardLayout/messages';
import OffreBlock from 'components/OffresBlock';
const Body = ({
  MyContracts,
  lastSinistre,
  ServicesBloc,
  Faq,
  ...otherProps
}: {
  intl: IntlShape;
  MyContracts: React.ReactNode;
  lastSinistre: React.ReactNode;
  ServicesBloc?: React.ReactNode;
  Faq: React.ReactNode;
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const OffreHeader = matches ? SmallSectionHeader : MediumSectionHeader;
  return (
    <StyledContainer maxWidth="lg">
      <Grid container spacing={2}>
        <Grid xs={12} md={8} item>
          <MyBlocContainer>
            <Box padding={3}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  {MyContracts}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {lastSinistre}
                </Grid>
                {ServicesBloc && (
                  <Grid item xs={12}>
                    <MyServicesWrapper>{ServicesBloc}</MyServicesWrapper>
                  </Grid>
                )}
              </Grid>
            </Box>
          </MyBlocContainer>
        </Grid>
        <Grid xs={12} sm md={4} item>
          <FAQWrapper>{Faq}</FAQWrapper>
        </Grid>
        <Grid xs={12} item>
          <OffreHeader>
            {translate({ ...messages.title_offres_conseils }, otherProps)}
          </OffreHeader>
          <OffreBlock />
        </Grid>
      </Grid>
    </StyledContainer>
  );
};

export default injectIntl(Body);
